import { FaSearch } from "react-icons/fa"
import { useTranslation } from "react-i18next"
import { FaUndoAlt } from "react-icons/fa"
import Spinner from "./Spinner"

export default function SearchBar({ onChange, value, handleReset, showSpinner = false }) {
  const { t } = useTranslation()

  const renderIcon = () => {
    if (value) {
      return <FaUndoAlt onClick={handleReset} data-testid='search-reset' />
    } else {
      return <FaSearch />
    }
  }

  return(
    <label
      className={`flex items-center justify-start w-full text-grey
      border border-grey rounded-full hover:cursor-pointer
      focus-within:text-grey-100 focus-within:border-grey-100`}
    >
      <div className="mx-1 w-4">
        {showSpinner ?
            <Spinner color="grey-300" height="20px" width="20px" strokeWidth={6} />
        :
          renderIcon()
        }
      </div>

      <input
        type="text"
        aria-label="search-units"
        autoComplete="off"
        className="w-full h-6 bg-grey-900 rounded-full border-none px-0.5
        focus:outline-none focus:border-grey-100 focus:ring-0
        placeholder:text-grey"
        onChange={(e) => onChange(e.target.value)}
        placeholder={t("Search")}
        value={value}
      />
    </label>
  )
}